<template>
  <div class="tools-container container-wrap">
    <easyads-head-top>
      <el-link>
        <router-link to="/">首页</router-link>
      </el-link>
      <el-divider direction="vertical"></el-divider>
      <el-link>
        <router-link to="/help">帮助文档</router-link>
      </el-link>
      <el-divider direction="vertical"></el-divider>
    </easyads-head-top>
    <div class="page-wrap">
      <div class="content">
        <el-row>
          <el-col :span="16">
            <div class="left">
              <div class="suppliers">
                <el-button type="primary" @click="addSupplier" size="small" style="margin:10px 10px 0 10px">+ 添加渠道</el-button>
                <div class="table-container">
                  <el-table
                    :data="supplierList"
                    style="width: 100%"
                    :height="350"
                  >
                    <el-table-column
                      prop="index"
                      label="渠道唯一标识"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="tag"
                      label="SDK类别标示"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="adspotId"
                      label="广告位id"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="appId"
                      label="appId"
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button @click="editSupplier(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="removeSupplier(scope.row)" type="text" size="small">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="rules">
                <el-button type="primary" @click="addRule" size="small" style="margin:10px 10px 0 10px">+ 添加策略</el-button>
                <div class="table-container">
                  <el-table
                    :data="ruleList"
                    style="width: 100%"
                    :height="supplierTableHeight"
                  >
                    <el-table-column
                      prop="tag"
                      label="策略组唯一标记"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="sort"
                      label="广告SDK执行顺序"
                      :formatter="ruleSortFormat"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="percent"
                      label="流量权重"
                    >
                      <template slot="header">
                        <span>流量权重</span>
                        <el-tooltip 
                          style="diaplay:inline" 
                          effect="dark" 
                          placement="top"
                          popper-class="rule-percent-tooltip"
                        >
                          <span slot="content">
                            流量权重：多策略分组时，会根据流量权重计算，为每个策略组分配流量比例，计算方法为 该组的权重值/所有策略组的权重之和
                          </span>
                          <i class="el-icon-question" />
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button @click="editRule(scope.row);" type="text" size="small">编辑</el-button>
                        <el-button @click="removeRule(scope.row)" type="text" size="small">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
               <el-button type="danger" icon="el-icon-delete" @click="reset" size="small" style="margin:10px 10px 0 10px">重置</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="right">
              <div class="title">
                <span style="margin-bottom:10px">聚合策略配置(JSON格式)</span>
                <el-button type="success" @click="copyJson" icon="el-icon-copy-document" size="small" style="float:right">复制</el-button>
              </div>
              
              <vue-json-editor 
                v-model="jsonData" 
                :show-btns="false" 
                :expandedOnStart="true"
                :style="style"
                :mode="'text'"
              ></vue-json-editor>
            </div>
          </el-col>
        </el-row>
      </div>

      <add-supplier
        ref="addSuppliersDialog"
        :dialogAddSuppliersVisible="dialogAddSuppliersVisible"
        :isEditSupplier=isEditSupplier
        @submit="submitSupplier"
        @cancel="dialogAddSuppliersVisible = false"
      ></add-supplier>

      <add-rule
        ref="addRulesDialog"
        :dialogAddRulesVisible="dialogAddRulesVisible"
        :isEditRule=isEditRule
        :ruleSortList=ruleSortList
        @submit="submitRule"
        @cancel="dialogAddRulesVisible = false"
      ></add-rule>
    </div>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor';
import addSupplier from '@/components/AddSuppliers.vue';
import addRule from '@/components/AddRules.vue';
import { sessionStorage } from '@/assets/js/storage';
export default {
  name: 'Tools',
  data () {
    return {
      style: 'height:' + (document.body.offsetHeight - 200) + 'px',
      supplierTableHeight: (document.body.offsetHeight - 260)/2,
      jsonData: {},

      // suppliers
      dialogAddSuppliersVisible: false,
      isEditSupplier: false,
      supplierList: [
        {
          index: 1,
          tag: 'csj',
          adspotId: '穿山甲SDK广告位id',
          appId: '穿山甲SDK应用id',
          isUsing: false,
        },
        {
          index: 2,
          tag: 'ylh',
          adspotId: '优量汇SDK广告位id',
          appId: '优量汇SDK应用id',
          isUsing: false
        },
        {
          index: 3,
          tag: 'ks',
          adspotId: '快手SDK广告位id',
          appId: '快手SDK应用id',
          isUsing: false
        },
        {
          index: 4,
          tag: 'bd',
          adspotId: '百度SDK广告位id',
          appId: '百度SDK应用id',
          isUsing: false
        },
      ],

      // rules
      isEditRule: false,
      dialogAddRulesVisible: false,
      ruleList: [],
    }
  },
  created() {
    // 初始化supplierList,ruleList，
    this.getOriginalSupplierList();
    this.getOriginalRuleList();
  },
  computed: {
    'ruleSortList' () {
      var ruleSortList = [];
      this.supplierList.forEach(item => {
        var obj = {};
        obj.value = item.index;
        obj.label = item.index + '-' + item.tag;

        ruleSortList.push(obj);
      })
      return ruleSortList;
    }
  },
  methods: {
    // 渠道相关
    // 获取当前的supplierList 列表。
    getOriginalSupplierList () {
      // 方便清空的时候使用；
      this.originalSupplierList = this.supplierList;

      var currentSupplierList = (sessionStorage.getItem('supplierList') && sessionStorage.getItem('supplierList').length > 0) ? sessionStorage.getItem('supplierList') : this.supplierList;
      sessionStorage.setItem('supplierList', currentSupplierList);
      this.supplierList = currentSupplierList;
      this.setJsonData();
    },

    openAddSupplierDialog (row) {
      this.dialogAddSuppliersVisible = true;
      this.$refs.addSuppliersDialog.open(row);
    },

    addSupplier () {
      this.isEditSupplier = false;
      this.openAddSupplierDialog();
    },

    editSupplier (row) {
      this.isEditSupplier = true;
      this.openAddSupplierDialog(row);
    },

    submitSupplier (supplierForm) {
      if (this.isEditSupplier) {
        this.editSupplierSubmit(supplierForm);
      } else {
        this.addSupplierSubmit(supplierForm);
      }
    },

    addSupplierSubmit (supplierForm) {
      this.supplierList.push(supplierForm);

      sessionStorage.setItem('supplierList', this.supplierList)
      sessionStorage.setItem('supplier_index', supplierForm.index);
      this.setJsonData();

      this.dialogAddSuppliersVisible = false;
    },

    editSupplierSubmit (supplierForm) {
      // 修改之前的supplierList
      var currentSupplierList = sessionStorage.getItem('supplierList');
      var currentSupplierIndex = currentSupplierList.findIndex(item => item.index == supplierForm.index);

      this.$set(currentSupplierList, currentSupplierIndex, supplierForm);
      this.supplierList = currentSupplierList;
      sessionStorage.setItem('supplierList', currentSupplierList);
      this.setJsonData();
      
      this.dialogAddSuppliersVisible = false;
      this.isEditSupplier = false;
    },

    removeSupplier (row) {
      // 删除渠道之前要确认，是否有rule.sort正在使用它，如果rule.sort 的长度为1，删除当前渠道的时候，就需要提示一下，有渠道正在使用它。
      var currentSupplierList = sessionStorage.getItem('supplierList');
      var currentSupplierIndex = currentSupplierList.findIndex(item => item.index == row.index);

      // 当有ruleList 的时候，要先判断是否有策略正在使用当前渠道。
      var isInUsingCurrentSupplier = false;
      if (this.ruleList.length) {
        this.ruleList.forEach(item => {
          var sortIndex = item.sort.findIndex(sortItem => sortItem == row.index);
          isInUsingCurrentSupplier = !(sortIndex == -1);
        
          if (isInUsingCurrentSupplier) {
            this.$confirm('有策略正在使用当前渠道，是否确定删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              item.sort.splice(sortIndex, 1);
              currentSupplierList.splice(currentSupplierIndex, 1);
              this.supplierList = currentSupplierList;
              sessionStorage.setItem('supplierList', currentSupplierList);
              sessionStorage.setItem('ruleList', this.ruleList);
              this.setJsonData();
              
              this.$message({
                type: 'success',
                message: '渠道删除成功!'
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            })
          }
        })
      }

      // ruleList 为空或者是没有正在使用当前渠道的策略时，可以直接删除。
      if (!this.ruleList.length || !isInUsingCurrentSupplier) {
        this.$confirm('是否要删除当前渠道', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          currentSupplierList.splice(currentSupplierIndex, 1);
          this.supplierList = currentSupplierList;
          sessionStorage.setItem('supplierList', currentSupplierList);
          this.setJsonData();

          this.$message({
            type: 'success',
            message: '当前策略删除成功!'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })
        return;
      }
    },

    // 策略相关
    getOriginalRuleList () {
      var currentRuleList = sessionStorage.getItem('ruleList') || [];
      sessionStorage.setItem('ruleList', currentRuleList);
      this.ruleList = currentRuleList;
      this.setJsonData();
    },

    ruleSortFormat (row) {
      let sortList = []
      row.sort.map((sortItem, index) =>{
        this.supplierList.map(supplierItem => {
          if (sortItem == supplierItem.index) {
            sortItem = supplierItem.index + '-' + supplierItem.tag;
            sortList.push(sortItem)
          }
        })
      })
      return sortList.join(',');
    },

    openAddRuleDialog (row) {
      this.dialogAddRulesVisible = true;
      this.$refs.addRulesDialog.open(row);
    },

    addRule () {
      this.isEditRule = false;
      this.openAddRuleDialog();
    },

    editRule (row) {
      this.isEditRule = true;
      this.openAddRuleDialog(row);
    },

    submitRule (ruleForm) {
      if (!this.isEditRule) {
        this.addRuleSubmit(ruleForm);
      } else {
        this.editRuleSubmit(ruleForm);
      }
    },

    addRuleSubmit (ruleForm) {
      this.ruleList.push(ruleForm);
      sessionStorage.setItem('ruleList', this.ruleList);
      this.setJsonData();
      this.dialogAddRulesVisible = false;
    },

    editRuleSubmit (ruleForm) {
      // 修改之前的supplierList
      var currentRuleList = sessionStorage.getItem('ruleList');
      var currentRuleIndex = currentRuleList.findIndex(item => item.tag == ruleForm.tag);

      this.$set(currentRuleList, currentRuleIndex, ruleForm);
      this.ruleList = currentRuleList;
      sessionStorage.setItem('ruleList', currentRuleList);
      this.setJsonData();
      
      this.dialogAddRulesVisible = false;
      this.isEditRule = false;
    },

    removeRule (row) {
      this.$confirm('是否要删除当前分发策略?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        var currentRuleList = sessionStorage.getItem('ruleList');
        var currentRuleIndex = currentRuleList.findIndex(item => item.tag == row.tag);

        currentRuleList.splice(currentRuleIndex, 1);
        this.ruleList = currentRuleList;
        sessionStorage.setItem('ruleList', currentRuleList);
        this.setJsonData();

        this.$message({
          type: 'success',
          message: '当前策略删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      })
    },

    setJsonData () {
      // jsonData 中的 suppliers需要筛选出策略中正在使用的渠道，不使用的渠道就不必展示在json配置文件中

      // 首先让supplierList 每一项的isUsing 都为 false,保证策略的删除，编辑之后，不被使用的渠道不会展示在json文件中
      this.supplierList.map(item => {
        item.isUsing = false;
      }) 
      this.ruleList.forEach(ruleItem => {
        this.supplierList.map((supplierItem, supplierindex) => {
          if (ruleItem.sort.includes(supplierItem.index)) {
            supplierItem.isUsing = true;
          } 
        })
      })
      var usingSupplierList = [];
      this.supplierList.map(item => {
        if (item.isUsing) {
          usingSupplierList.push({ index: item.index, tag:item.tag, adspotId: item.adspotId, appId: item.appId});
        }
      })
      this.jsonData = {
        rules: this.ruleList,
        suppliers: usingSupplierList
      }
    },

    reset () {
      this.$confirm('是否要清空所有渠道和策略', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.supplierList = this.originalSupplierList;
        this.ruleList = [];
        sessionStorage.setItem('supplierList', this.supplierList);
        sessionStorage.setItem('ruleList', this.ruleList);
        sessionStorage.setItem('supplier_index', 4)
        this.setJsonData();

        this.$message({
          type: 'success',
          message: '已清空所有渠道和策略！'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        })
      })
    },

    // 复制
    copyJson () {
      this.$copyText(JSON.stringify(this.jsonData, null, 2)).then(() => {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      }, () => {
        this.$message({
          type: 'error',
          message: '复制失败'
        })
      })
    }
  },
  components: {
    vueJsonEditor,
    addSupplier,
    addRule
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scpoed>
.tools-container {
  .page-wrap {
    .content {
      margin-top: 80px;
      .right {
        height: 100%;
        text-align: center;
        background-color: #fff;
        padding: 0 20px 20px 20px;

        .title {
          line-height: 30px;
          padding: 10px;
          & > span {
            font-size: 18px;
            font-weight: 500;
          }
        }
      }
      .left {
        height: 100%;
        margin-right: 30px;

        .suppliers,
        .rules {
          margin-bottom: 10px;
          background-color: #fff;
        }
        .save-json {
          float: right;
        }
      }
    }
  }
}
.rule-percent-tooltip {
  width: 300px;
}
.jsoneditor-vue {
  height: 100%;
}
.table-container {
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/tools/index.vue